export default "__VITE_ASSET__c48ba732__"